import React from 'react';
import SectionTitle from '../SectionTitle/SectionTitle';
import { Link } from 'react-router-dom';

const FeaturesSection = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const { SectionTitleShow = true } = props;

  return (
    <section className={'' + props.hclass}>
      <div className='container'>
        {SectionTitleShow && (
          <div className='row justify-content-center'>
            <div className='col-lg-8 col-12'>
              <SectionTitle
                subtitle='Why Choose Ferry Gold Shipping'
                title='Fast, secure, and reliable logistics solutions worldwide'
              />
            </div>
          </div>
        )}

        <div className='features-wrap'>
          <div className='features-card'>
            <i className='flaticon-logistics'></i>
            <h3>
              Complete
              <br />
              Logistics Solutions
            </h3>
          </div>

          <div className='features-card'>
            <i className='flaticon-fast-delivery-1'></i>
            <h3>
              Fast
              <br />
              Freight Delivery
            </h3>
          </div>

          <div className='features-card'>
            <i className='flaticon-locations'></i>
            <h3>
              Shipment
              <br />
              Tracking Support
            </h3>
          </div>

          <div className='features-card'>
            <i className='flaticon-logistics-1'></i>
            <h3>
              International
              <br />
              Shipping Services
            </h3>
          </div>

          <div className='features-card'>
            <i className='flaticon-customer-support'></i>
            <h3>
              Dedicated
              <br />
              Customer Support
            </h3>
          </div>
        </div>

        <div className='row'>
          <div className='col-12'>
            <h4>Moving your cargo with care, speed, and reliability. </h4>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
